import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../app/user/user.service';
import { Observable, Subject } from 'rxjs';
import { filter, distinctUntilChanged, takeUntil } from 'rxjs/operators';



/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage(
  {
    name: 'change-password'
  })
@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {
  public isLoading$: Observable<boolean>;
  public userPasswordForm: any; 
  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public prevPage: string;
  public user: any;
  public oldPasswordCorrect: boolean = true;
  public confirmOpen: boolean = false;

  passForm: any;

  private unsubscribe: Subject<void> = new Subject<void>()

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams, 
    public viewCtrl: ViewController, 
    public userService: UserService,
  ) {

    this.userPasswordForm = new FormGroup({
      oldPassword: new FormControl(this.oldPassword, {
        validators: [Validators.required, Validators.minLength(8)]
      }),
      newPassword: new FormControl(this.newPassword, {
        validators: [Validators.required, Validators.minLength(8)]
      })
    });
  }

  ngOnInit() {
    this.userService.currentUser$.pipe(
      takeUntil(this.unsubscribe),
      filter(user => (!!user)),
      distinctUntilChanged()
    ).subscribe((user) => {
      if (user && user.activeGroup) {
        this.user = user;
      }
    });
  }

  ionViewDidLoad() {
    if(this.navCtrl.getPrevious() !== null){
      this.prevPage = this.navCtrl.getPrevious().id;
    }
  }


  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async savePassword(){
    if(this.oldPassword && this.newPassword){
      const newPassword = await this.userService
        .updatePassword(this.oldPassword, this.newPassword);

      if(newPassword){
        //this.navCtrl.setRoot('dashboard');
        this.confirmOpen = true;
      }
      else{
        this.oldPasswordCorrect = false;
      }
    } else {
      this.userPasswordForm.controls['oldPassword'].markAsTouched()
      this.userPasswordForm.controls['newPassword'].markAsTouched()
    }
  }

  onSubmitAction(event){
    this.confirmOpen = event;
  }
}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts